import { useRef } from 'react';

import Button from './Button';
import useInput from '../hooks/use-input';

import emailjs from '@emailjs/browser';

const BasicForm = (props) => {
  const form = useRef();

  //name
  const {
    value: enteredFirstName,
    hasError: firstNameInputHasError,
    isValid: enteredFirstNameIsValid,
    valueChangeHandler: firstNameChangedHandler,
    inputBlurHandler: firstNameBlurHandler,
    reset: resetFirstNameInput,
  } = useInput((value) => value.trim() !== '');

  //Email
  const {
    value: enteredEmail,
    hasError: emailInputHasError,
    isValid: enteredEmailIsValid,
    valueChangeHandler: emailChangedHandler,
    inputBlurHandler: emailBlurHandler,
    reset: resetEmailInput,
  } = useInput((value) => value.includes('@'));

  //subject
  const {
    value: enteredSubject,
    hasError: subjectInputHasError,
    isValid: enteredSubjectIsValid,
    valueChangeHandler: subjectChangedHandler,
    inputBlurHandler: subjectBlurHandler,
    reset: resetSubjectInput,
  } = useInput((value) => value.trim() !== '');

  //message
  const {
    value: enteredMessage,
    hasError: messageInputHasError,
    isValid: enteredMessageIsValid,
    valueChangeHandler: messageChangedHandler,
    inputBlurHandler: messageBlurHandler,
    reset: resetMessageInput,
  } = useInput((value) => value.trim() !== '');

  let formIsValid = false;

  if (
    enteredFirstNameIsValid &&
    enteredSubjectIsValid &&
    enteredEmailIsValid &&
    enteredMessageIsValid
  ) {
    formIsValid = true;
  }

  //form submission handler

  const formSubmissionHandler = (e) => {
    e.preventDefault();
    console.log(enteredFirstName);
    console.log(enteredSubject);
    console.log(enteredEmail);

    if (!formIsValid) {
      return;
    }

    emailjs
      .sendForm(
        'service_9z0podf',
        'template_exwy49p',
        form.current,
        'BrPlcMcsYOMh2ajY7'
      )
      .then(
        (res) => {
          console.log(res.text);
          alert('Message successfully sent!');
          window.location.reload(false);
        },
        (error) => {
          console.log(error.text);
          alert('Failed to send the message, please try again');
        }
      );

    resetFirstNameInput();
    resetEmailInput();
    resetSubjectInput();
    resetMessageInput();
  };

  const nameInputError = firstNameInputHasError
    ? 'form-box__form-group--input name invalid'
    : 'form-box__form-group--input name';

  const emailInputError = emailInputHasError
    ? 'form-box__form-group--input email invalid'
    : 'form-box__form-group--input email';

  const subjectInputError = subjectInputHasError
    ? 'form-box__form-group--input subject invalid'
    : 'form-box__form-group--input subject';

  const messageInputError = messageInputHasError
    ? 'form-box__form-group--input message invalid'
    : 'form-box__form-group--input message';

  return (
    <section className="form-box">
      <p className="form-box__warning">
        <span>*</span>Required information
      </p>
      <form
        className="form-box__form-group"
        ref={form}
        onSubmit={formSubmissionHandler}
      >
        <label className="form-box__form-group--label name" htmlFor="name">
          Name *
        </label>
        <input
          className={nameInputError}
          type="text"
          id="name"
          name="from_name"
          placeholder={
            !firstNameInputHasError
              ? 'Enter your name.'
              : 'Please enter your name.'
          }
          onChange={firstNameChangedHandler}
          onBlur={firstNameBlurHandler}
          value={enteredFirstName}
        />

        <label className="form-box__form-group--label email" htmlFor="email">
          E-Mail *
        </label>
        <input
          className={emailInputError}
          type="email"
          id="email"
          name="from_email"
          placeholder={
            !emailInputHasError
              ? 'Enter your email.'
              : 'Please enter a valid email'
          }
          onChange={emailChangedHandler}
          onBlur={emailBlurHandler}
          value={enteredEmail}
        />

        <label
          className="form-box__form-group--label subject"
          htmlFor="subject"
        >
          Subject *
        </label>
        <input
          className={subjectInputError}
          type="text"
          id="subject"
          name="subject"
          placeholder={
            !subjectInputHasError
              ? 'Enter a subject.'
              : 'Please enter a valid subject.'
          }
          onChange={subjectChangedHandler}
          onBlur={subjectBlurHandler}
          value={enteredSubject}
        />

        <label
          className="form-box__form-group--label message"
          htmlFor="message"
        >
          Message *
        </label>
        <textarea
          rows="8"
          className={messageInputError}
          type="text-area"
          // type="submit"
          id="message"
          placeholder={
            !messageInputHasError
              ? 'Enter your message.'
              : 'Please enter a valid message'
          }
          name="message"
          onChange={messageChangedHandler}
          onBlur={messageBlurHandler}
          value={enteredMessage}
        />

        <div className="action">
          <Button cssClass="action__btn" text="send" disabled={!formIsValid} />
        </div>
      </form>
    </section>
  );
};

export default BasicForm;
